import React, { Component } from 'react';
import classNames from 'classnames';

class CircleWithBorder extends Component {

    render() {
        const { children, size } = this.props;
        const circleClasses = classNames(
            'circle-with-border',
            { 'large': size === "large" }
        );

        return(
            <div className={circleClasses}>
                <div className="circle-with-border-content">
                    { children }
                </div>
            </div>
        );
    }

}

export default CircleWithBorder;



// WEBPACK FOOTER //
// ./src/components/circle-with-border.js